<template lang="html">
  <div class="container" id="text-page">

    <h1 class="mb-3 page-title">Contrato para vendedores.</h1>

    <div class="content" v-html="row"></div>

    <!-- <div class="content">
      <p>
        Celebrado entre el Productor (persona física o moral que se registra en la plataforma Bazaar Flex para vender productos) y Bazaar Flex S.A. DE C.V., con domicilio en Sienita 2074, Colonia Mariano Otero, Zapopan, Jalisco, México, C.P. 45067.
      </p>

      <br />
      <h5>1. OBJETO</h5>
      <p>
        Regular la relación entre Bazaar Flex y el Productor para la comercialización de productos en el marketplace digital.
      </p>

      <br />
      <h5>2. INTERMEDIACIÓN</h5>
      <p>
        Bazaar Flex actúa únicamente como intermediario. No adquiere propiedad sobre los productos ni garantiza calidad, cumplimiento normativo, funcionalidad, ni condiciones de seguridad.
      </p>

      <br />
      <h5>3. OBLIGACIONES DEL PRODUCTOR</h5>
      <ul>
        <li>Registrar datos verídicos.</li>
        <li>Cumplir con leyes fiscales y sanitarias.</li>
        <li>Ofrecer productos legales, auténticos y funcionales.</li>
        <li>Cumplir con tiempos de envío.</li>
        <li>Atender devoluciones, reclamos y postventa.</li>
        <li>Emitir comprobantes fiscales cuando aplique.</li>
      </ul>

      <br />
      <h5>4. COMISIONES</h5>
      <p>
        El Productor autoriza la retención de una comisión por parte de Bazaar Flex, cuyo porcentaje será acordado previamente. Los pagos se efectuarán entre 5 y 10 días hábiles después de confirmada la entrega.
      </p>

      <br />
      <h5>5. PROPIEDAD INTELECTUAL</h5>
      <p>
        El Productor conserva la titularidad de su marca, pero otorga a Bazaar Flex una licencia gratuita y no exclusiva para promocionar sus productos dentro y fuera de la plataforma.
      </p>

      <br />
      <h5>6. TERMINACIÓN</h5>
      <p>
        Cualquiera de las partes podrá dar por terminado el contrato con 15 días de aviso. Órdenes pendientes deberán cumplirse. Bazaar Flex podrá cancelar la cuenta en caso de fraude o incumplimiento.
      </p>

      <br />
      <h5>7. LIMITACIÓN DE RESPONSABILIDAD</h5>
      <p>
        Bazaar Flex no garantiza ventas ni se responsabiliza por quejas del cliente sobre el producto.
      </p>

      <br />
      <h5>8. JURISDICCIÓN</h5>
      <p>
        Leyes de México. Tribunales competentes de Zapopan, Jalisco.
      </p>

      <br />
      <h5>9. ACEPTACIÓN</h5>
      <p>
        El Productor acepta el presente contrato al momento de registrarse y marcar la casilla correspondiente dentro del formulario de afiliación.
      </p>

      <br />
      <h5>10. PRODUCTOS PROHIBIDOS</h5>
      <p>
        El Productor se compromete a no ofertar ni intentar vender a través de la plataforma Bazaar Flex los siguientes tipos de productos:
      </p>
      <ul>
        <li>Armas de fuego, municiones o explosivos.</li>
        <li>Cualquier tipo de material pornográfico o contenido sexual explícito.</li>
        <li>Drogas, narcóticos, sustancias controladas o precursores químicos.</li>
        <li>Productos o contenido que incite al odio, la discriminación, la violencia o el terrorismo.</li>
        <li>Seres vivos, incluyendo animales, insectos o plantas, salvo autorización expresa de Bazaar Flex.</li>
      </ul>

      <p>
        La publicación, promoción o intento de venta de cualquiera de estos productos constituirá una falta grave y resultará en la suspensión inmediata de la cuenta del productor, la eliminación de los productos relacionados, y la notificación formal a las autoridades competentes.
      </p>

      <br />
      <h5>11. COMISIONES Y CONDICIONES DE PAGO</h5>
      <p>
        El Productor acepta que Bazaar Flex cobrará una comisión equivalente al 20% (veinte por ciento) del valor total de cada venta concretada a través de la plataforma.
      </p>

      <br />
      <p>
        El pago correspondiente al Productor se realizará únicamente una vez que el comprador haya confirmado la recepción del producto en condiciones adecuadas, conforme a la descripción publicada y dentro de los parámetros acordados. Bazaar Flex validará dicha confirmación antes de liberar el monto correspondiente, restando la comisión aplicable.
      </p>

      <br />
      <p>
        Bazaar Flex se reserva el derecho de retener el pago si existe una disputa abierta, reclamo formal o evidencia de incumplimiento por parte del Productor. En tales casos, el pago se liberará una vez resuelto el conflicto, conforme a lo estipulado en los presentes términos.
      </p>
    </div> -->
  </div>
</template>

<script>
export default {
  data(){
    return{
      row:null,
    }
  },

  methods: {
    getData: function(){
      axios.get(tools.url('/api/contrato')).then((response)=>{
        this.row = response.data.body;
      }).catch((error)=>{
      })
    },
  },

  mounted(){
      this.getData();
  },
}
</script>
